import './title.css';

function Title(props: TitleProps) {
    return (
        <>
            <p className='comp-title'>{props.value}</p>
        </>);

}

interface TitleProps {
    value: string
}

export { Title }